import { render, staticRenderFns } from "./IcoCompetency.vue?vue&type=template&id=1fada624"
import script from "./IcoCompetency.vue?vue&type=script&lang=js"
export * from "./IcoCompetency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports